module.exports = __webpack_public_path__ + "media/honey_heist.3ea3ec2a.webm";